var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "hidden relative lg:flex items-center bg-indigo-200 overflow-visible rounded-sm h-48 w-full"
  }, [_vm._m(0), _vm._v(" "), _c('illustration', {
    staticClass: "hidden xl:block absolute right-5 xl:right-10 w-60 xl:w-72",
    attrs: {
      "name": "help"
    }
  })], 1), _vm._v(" "), _vm.$can(_vm.constants.PERMISSION_AIDE_CONSULTER) ? _c('div', {
    staticClass: "flex flex-col mt-16 mb-8"
  }, [_c('MessageHeader', {
    attrs: {
      "message-header": _vm.$store.state.help.messageHeader
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "relative align-middle min-w-full shadow sm:rounded-lg border-b border-gray-200 bg-white pb-10 table min-h-halfscreen"
  }, [_c('router-view')], 1)], 1) : _c('page-not-allowed')], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "px-12"
  }, [_c('p', {
    staticClass: "text-4xl text-gray-900"
  }, [_vm._v("Aide")]), _vm._v(" "), _c('p', {
    staticClass: "mt-2 text-base font-light leading-4 2xl:leading-5 text-gray-600"
  }, [_vm._v("\n        Formulaire de contact\n      ")])]);

}]

export { render, staticRenderFns }